import { useContext } from "react";
import About from "./components/about/About";
import Contact from "./components/contact/Contact";
import Intro from "./components/intro/Intro";
import Skills from "./components/skills/Skills";
import Project from "./components/project/Project";
import ProjectList from "./components/projectList/ProjectList";
import { ThemeContext } from "./context";
import Navbar from "./components/navbar/Navbar";
import {Switch} from 'react-router-dom'
import {Route} from "react-router-dom"
const App = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  return (
    <Switch>
    <div
      style={{
        backgroundColor: darkMode ? "#222" : "white",
        color: darkMode && "white",
      }}
    >
      <Navbar />
      <Route path="/" exact>
      <Intro />
      <About />
      <Skills/>
      <ProjectList />
      <Contact />
      </Route>

      <Route path="/intro" >
      <About />
      </Route>
      
      <Route path="/skills" >
      <Skills />
      </Route>

      <Route path="/about" >
      <About />
      </Route>
     
        <Route path="/project">
          <ProjectList />
        </Route>
      

      <Route path="/contact" >
      <Contact />
      </Route>
      </div>
      </Switch>
  );
};

export default App;
